<template>
  <div
    @keyup.esc="hidden = true"
    :class="[baseCss, disabled ? ['disabled', 'pointer-events-none'] : null, `bcq-menu-list-${opener}`]"
    role="listbox"
    ref="dropdown">
    <div :class="['relative']">
      <div @click="toggleHidden">
        <btn
          @keyup.esc.native="hidden = true"
          v-if="['btn', 'split-btn'].includes(opener)"
          :outlined="outlined"
          :bg-color="bgColor"
          :bg-color-lightness="bgColorLightness"
          :color="color"
          :bold="bold"
          :uppercase="uppercase"
          :size="size"
          :elevation="elevation"
          :color-lightness="colorLightness"
          :icon-left="icon ? icon : null"
          :rounded="rounded"
          :width="openerWidth"
          :icon-right="chevron ? `chevron-${hidden ? 'down' : 'up'}` : null">
          {{ headerText }}
        </btn>
        <avatar
          v-if="opener === 'avatar'"
          :size="openerWidth"
          :text="avatarText"
          :bg-color="avatarBgColor"
          :bg-color-lightness="avatarBgColorLightness"
          :src="avatarSrc"
          :elevation="elevation"
          :class="['cursor-pointer']" />
      </div>
      <card @keyup.esc.native="hidden = true" @click.native="toggleHidden" v-if="!disabled && $slots.list" :class="['absolute', hidden ? 'hidden' : null, `${dropdownPosition}-0`]" :style="{zIndex, width}" :elevation="elevation">
        <card-text padding-off :style="{maxHeight}" :class="['overflow-auto', `text-${size}`]">
          <slot name="list" />
        </card-text>
      </card>
    </div>
  </div>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'

export default {
  name: 'MenuList',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('menu-list', ['select-none', 'inline-block', 'align-middle']),
      hidden: true
    }
  },
  props: {
    dropdownPosition: {
      type: String,
      default: 'left',
      validator: value => {
        return ['left', 'right'].includes(value)
      }
    },
    outlined: {
      type: Boolean
    },
    uppercase: {
      type: Boolean,
      default: true
    },
    bold: {
      type: Boolean,
      default: true
    },
    rounded: {
      type: Boolean,
      default: true
    },
    zIndex: {
      type: Number,
      default: 1500
    },
    headerText: {
      type: String
    },
    avatarSrc: {
      type: String
    },
    avatarText: {
      type: String
    },
    avatarBgColor: {
      type: String
    },
    avatarBgColorLightness: {
      type: Number
    },
    chevron: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: 'auto'
    },
    disabled: {
      type: Boolean
    },
    size: {
      type: String,
      default: 'sm'
    },
    opener: {
      type: String,
      default: 'btn',
      validator: value => {
        return ['btn', 'avatar', 'split-btn'].includes(value)
      }
    },
    bgColor: {
      type: String,
      default: 'gray'
    },
    color: {
      type: String,
      default: 'white'
    },
    openerWidth: {
      type: String,
      default: 'auto'
    },
    maxHeight: {
      type: String
    }
  },
  created () {
    document.addEventListener('click', this.documentClick)
  },
  destroyed () {
    document.removeEventListener('click', this.documentClick)
  },
  methods: {
    toggleHidden () {
      if (!this.disabled) {
        this.hidden = !this.hidden
      }
    },
    documentClick (e) {
      let el = this.$refs['dropdown']
      let target = e.target
      if (el !== target && !el.contains(target)) {
        this.hidden = true
      }
    }
  }
}
</script>
<style>
.bcq-menu-list.bcq-menu-list-split-btn .bcq-btn-text
{
  border-right: solid 1px var(--semi-transparent-light);
  padding-right: 14px;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/menu-list/menu-list.vue